const ProductStatus = Object.freeze({
	LOADING: 'loading',
	SUCCESS: 'success',
	ERROR: 'error',
});

const StepTypes = Object.freeze({
	COLLECTIONS: 'Collections',
	PRESCRIPTION: 'Prescription',
	LENSES: 'Lenses',
});

const StepOrder = Object.freeze({
	DEFAULT: ['Collections', 'Prescription', 'Lenses'],
});

const PrescriptionTypes = Object.freeze({
	DEFAULT: ['Single-Vision', 'Progressives', 'Readers', 'Non-Prescription'],
	BLUE_LIGHT: ['Non-Prescription', 'Single-Vision', 'Progressives', 'Readers'],
	SUN_LENS: ['Non-Prescription', 'Single-Vision', 'Progressives', 'Readers'],
});

const LensSkus = Object.freeze({
	BLUE_LIGHT: 'BLUE_LIGHT',
	ULTRA_THIN: 'ULTRA_THIN',
	PROGRESSIVE: 'PROGRESSIVE',
	SUN_LENS: 'SUN_LENS',
	LIGHT_RESPONSIVE: 'LIGHT_RESPONSIVE',
});

const HiddenLensOptions = Object.freeze({
	DEFAULT: {
		'Single-Vision': [LensSkus.PROGRESSIVE, LensSkus.SUN_LENS],
		'Progressives': [LensSkus.PROGRESSIVE, LensSkus.SUN_LENS], //intentional; hides option from view
		'Readers': [LensSkus.PROGRESSIVE, LensSkus.ULTRA_THIN, LensSkus.SUN_LENS],
		'Non-Prescription': [LensSkus.PROGRESSIVE, LensSkus.ULTRA_THIN, LensSkus.SUN_LENS],
	},
	BLUE_LIGHT: {
		'Non-Prescription': [LensSkus.BLUE_LIGHT, LensSkus.PROGRESSIVE, LensSkus.ULTRA_THIN, LensSkus.SUN_LENS],
		'Single-Vision': [LensSkus.BLUE_LIGHT, LensSkus.PROGRESSIVE, LensSkus.SUN_LENS],
		'Progressives': [LensSkus.BLUE_LIGHT, LensSkus.PROGRESSIVE, LensSkus.SUN_LENS],
		'Readers': [LensSkus.BLUE_LIGHT, LensSkus.PROGRESSIVE, LensSkus.ULTRA_THIN, LensSkus.SUN_LENS],
	},
	SUN_LENS: {
		'Non-Prescription': [LensSkus.SUN_LENS, LensSkus.PROGRESSIVE, LensSkus.ULTRA_THIN, LensSkus.SUN_LENS],
		'Single-Vision': [LensSkus.SUN_LENS, LensSkus.PROGRESSIVE, LensSkus.SUN_LENS],
		'Progressives': [LensSkus.SUN_LENS, LensSkus.PROGRESSIVE, LensSkus.SUN_LENS],
		'Readers': [LensSkus.SUN_LENS, LensSkus.PROGRESSIVE, LensSkus.ULTRA_THIN, LensSkus.SUN_LENS],
	},
});

const ActionCopy = Object.freeze({
	[StepTypes.COLLECTIONS]: window.bfReorder ? 'Add to Cart' : 'Select Lens Type',
	[StepTypes.PRESCRIPTION]: 'Select an Option',
	[StepTypes.LENSES]: window.bfReorder ? 'Choose Top Frames' : 'Add to Cart',
});

const DataTagCopy = Object.freeze({
	[StepTypes.COLLECTIONS]: 'data-select-lens-type',
	[StepTypes.PRESCRIPTION]: '',
	[StepTypes.LENSES]: 'data-add-to-cart',
});

const JourneyPrices = Object.freeze({
	DEFAULT: {
		'Single-Vision': null,
		'Progressives': 199,
		'Readers': 0,
		'Non-Prescription': 0,
	},
	BLUE_LIGHT: {
		'Non-Prescription': null,
		'Single-Vision': 49,
		'Progressives': 248,
		'Readers': 49,
	},
	SUN_LENS: {
		'Non-Prescription': null,
		'Single-Vision': 99,
		'Progressives': 298,
		'Readers': 99,
	},
});

const JourneyCopy = Object.freeze({
	DEFAULT: {
		Prescriptions: 'Select your Prescription Type',
		Lenses: 'Customize your Lenses',
	},
	BLUE_LIGHT: {
		Prescriptions: 'Select your Blue Light Prescription Type',
		Lenses: 'Customize your Blue Light Lenses',
	},
	SUN_LENS: {
		Prescriptions: 'Select your Sun Lens Prescription Type',
		Lenses: 'Customize your Sun Lenses',
	},
});

const JourneyHiddenLenses = Object.freeze({
	DEFAULT: [],
	BLUE_LIGHT: ['Blue Light Filtering', 'Sunglass Lens'],
	SUN_LENS: ['Blue Light Filtering', 'Sunglass Lens'],
});

const NonRxOptions = Object.freeze({ READERS: 'Readers', NON_PRESCRIPTION: 'Non-Prescription' });

const ReaderStrengthOptions = ['0.25', '0.50', '0.75', '1.00', '1.25', '1.50', '1.75', '2.00', '2.25', '2.50', '2.75'];

const ProductHeights = Object.freeze({
	[StepTypes.COLLECTIONS]: '200px',
	[StepTypes.PRESCRIPTION]: '0',
	[StepTypes.LENSES]: '0',
});

const CUSTOMER_JOURNEYS = Object.freeze({
	DEFAULT: 'DEFAULT',
	BLUE_LIGHT: 'BLUE_LIGHT',
	SUN_LENS: 'SUN_LENS',
});

const PRESCRIPTION_TYPES = Object.freeze({
	NON_PRESCRIPTION: 'Non-Prescription',
	PROGRESSIVES: 'Progressives',
	READERS: 'Readers',
	SINGLE_VISION: 'Single-Vision',
});

const AFFIRM_LINK = 'https://www.affirm.com/how-it-works';
const DEFAULT_BASE_FRAME_SHAPE = 'Larkin';
const DEFAULT_DEMO_FOR_IMAGE_NAME = 'default';
const DEFAULT_JOURNEY_FOR_IMAGE_NAME = 'eyeglasses';
const FLAG_BEST_SELLER_STRING = 'badge-best';
const FRAME_COLOR_IMAGE_LINKS = {
	'Black': 'https://cdn.shopify.com/s/files/1/1147/9910/files/Black-Swatch.png?v=1635540948',
	'Blue Clear': 'https://cdn.shopify.com/s/files/1/1147/9910/files/Blue-Clear-Swatch.png?v=1635540948',
	'Blue Tortoise': 'https://cdn.shopify.com/s/files/1/1147/9910/files/Blue-Tortoise-Swatch.png?v=1635540948',
	'Crystal Clear': 'https://cdn.shopify.com/s/files/1/1147/9910/files/Crystal-Clear-Swatch.png?v=1635540948',
	'Pink Clear': 'https://cdn.shopify.com/s/files/1/1147/9910/files/Pink-Clear-Swatch.png?v=1635540948',
	'Tortoise': 'https://cdn.shopify.com/s/files/1/1147/9910/files/Tortoise-Swatch.png?v=1635540948',
};
const LOCAL_STORAGE = Object.freeze({
	ACTIVE_FRAME_SHAPE: 'activeFrameShape',
});
const MEDIUM_WIDTH = 768;
const MOBILE_MAX_WIDTH = 551;
const SUN_TOPS_HANDLE = 'sun-tops';
const TESTING_URL = 'http://127.0.0.1:9292';
const YOTPO_APP_KEY = '6PFOlr7C6ePRRzDTwncsF8anUFfjmRtdVTeqcnXZ';

const ACCOUNT_TABS = Object.freeze({
	MY_FAVORITES: 'My Favorites',
	MY_COLLECTION: 'My Collection',
	MY_ORDERS: 'My Orders',
	MY_REWARDS: 'My Rewards',
});

const ACCOUNT_TABS_LINKS = Object.freeze({
	MY_FAVORITES: 'favorites',
	MY_COLLECTION: 'collections',
	MY_ORDERS: 'orders',
	MY_REWARDS: 'rewards',
});

const PRODUCT_TYPES = Object.freeze({
	BASE_FRAME: 'BASE_FRAME',
	TOP_FRAME: 'TOP_FRAME', // Note: The actual Shopify type is 'TOP_FRAME__<COLLECTION>'
	LENS: 'LENS',
	ACCESSORY: 'ACCESSORY',
	GIFT_CARD: 'Gift Card',
});

const COURIER_OPTIONS = Object.freeze({
	DHL: 'DHL',
	UPS: 'UPS',
	USPS: 'USPS',
	FEDEX: 'FEDEX',
	LANDMARK: 'LANDMARK',
	CANADA_POST: 'CANADA',
});

const YOTPO = Object.freeze({
	ACTIVITY_WIDGET_STYLE1_ID: '174304',
	ACTIVITY_WIDGET_STYLE2_ID: '174298',
	CAMPAIGNS_WIDGET_ID: '190231',
	VIP_TIERS_WIDGET_ID: '190232',
	REFER_A_FRIEND_WIDGET_ID: '190229',
	REWARDS_PAGE_WIDGET_ID: '190227',
	SCRIPT_URL: 'https://cdn-widgetsrepository.yotpo.com/v1/loader/SYWNHwPkPCmfBqVKaZFjGQ',
	REVIEWS_SCRIPT_URL: '//staticw2.yotpo.com/6PFOlr7C6ePRRzDTwncsF8anUFfjmRtdVTeqcnXZ/widget.js',
});

const SECTION_TYPES = Object.freeze({
	HERO: 'react-hero-carousel-section',
	HOW_IT_WORKS: 'react-how-it-works-section',
	TEXT: 'react-text-section',
	SPLIT: 'react-split-section',
	GRAPHIC_TEXT: 'react-graphic-text-section',
	LENS_OPTIONS: 'react-lens-options-section',
	FEATURED_TOPS: 'featured-tops',
	PLP_PRODUCT_LIST: 'react-plp-product-list',
	PLP_TOPS_PRODUCT_LIST: 'react-plp-tops-product-list',
	PLP_ALL_TOPS_PRODUCT_LIST: 'react-plp-all-tops-product-list',
	PLP_ALL_TOPS_PRODUCT_LIST_GIFT_GUIDE: 'react-plp-all-tops-product-list-gift-guide',
	PLP_ALL_TOPS_PRODUCT_LIST_LIMITED: 'react-plp-all-tops-product-list-limited',
	PLP_ALL_TOPS_PRODUCT_LIST_LICENSED: 'react-plp-all-tops-product-list-licensed',
	BLOG_LIST: 'react-blog-section',
	BLOG_ARTICLE: 'react-article-section',
	ABOUT_BANNER: 'react-about-banner',
	ABOUT_CTA: 'react-about-cta',
	ABOUT_BODY: 'react-about-body',
	YOTPO_REWARDS_WIDGET: 'react-yotpo-rewards-widget-section',
	CART: 'react-cart',
});

const BASE_FRAME_NAMES = Object.freeze([
	'Cedro',
	'Serra',
	'Otero',
	'Twain',
	'Larkin',
	'Kirby',
	'Casper',
	'Reese',
	'Otis',
	'Soto',
	'Finley',
	'Ella',
	'Wanda',
]);

const LENS_COLOR_NAMES = Object.freeze([
	'Black',
	'Brown',
	'Green',
	'Silver Reflective',
	'Pink Reflective',
	'Blue Reflective',
	'Green Reflective',
]);

const BADGE_TYPES = Object.freeze({
	LIMITED: {
		name: 'limited-edition',
		displayText: 'Limited Edition',
	},
	SOON: {
		name: 'coming-soon',
		displayText: 'Coming Soon',
	},
	LAUNCHED: {
		name: 'just-launched',
		displayText: 'Just Launched!',
	},
});

const COUNTDOWN_COPY = Object.freeze({
	LAUNCH: 'Time remaining until drop',
	EXPIRY: 'Collection leaving soon!',
});

const RX_CELL_TYPES = {
	REMIND: 'remind',
	PHOTO: 'photo',
	DOCTOR: 'doctor',
};

const TOOLTIP_COPY = {
	ULTRA_THIN:
		'These 1.67 high-index lenses are recommended for complex prescriptions but are not recommended for people under 18 as they are less impact resistant.',
};

export {
	ProductStatus,
	StepTypes,
	StepOrder,
	PrescriptionTypes,
	ActionCopy,
	DataTagCopy,
	JourneyCopy,
	JourneyHiddenLenses,
	JourneyPrices,
	NonRxOptions,
	HiddenLensOptions,
	LensSkus,
	ReaderStrengthOptions,
	ProductHeights,
	ACCOUNT_TABS,
	ACCOUNT_TABS_LINKS,
	AFFIRM_LINK,
	COURIER_OPTIONS,
	CUSTOMER_JOURNEYS,
	DEFAULT_BASE_FRAME_SHAPE,
	DEFAULT_DEMO_FOR_IMAGE_NAME,
	DEFAULT_JOURNEY_FOR_IMAGE_NAME,
	FLAG_BEST_SELLER_STRING,
	FRAME_COLOR_IMAGE_LINKS,
	LOCAL_STORAGE,
	MEDIUM_WIDTH,
	MOBILE_MAX_WIDTH,
	PRESCRIPTION_TYPES,
	PRODUCT_TYPES,
	SUN_TOPS_HANDLE,
	TESTING_URL,
	YOTPO_APP_KEY,
	YOTPO,
	SECTION_TYPES,
	BASE_FRAME_NAMES,
	LENS_COLOR_NAMES,
	BADGE_TYPES,
	COUNTDOWN_COPY,
	RX_CELL_TYPES,
	TOOLTIP_COPY,
};
